import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/Dashboard'
import { localized } from '@/decorators/localized'
import NoWidgetsMessage from '@/components/dashboard/noWidgetsMessage'
import LoadingIndicator from '@/components/LoadingIndicator'
export { ReportSubmissionsWidget } from './reportSubmissions'
export { TasksWidget } from './tasks'
export { MessagesWidget } from './messages'
export { NotificationsWidget } from './notifications'

@localized()
class Widgets extends React.Component {
  componentDidMount () {
    this.props.getDashboardWidgets()
  }
  renderWidget = (item, index, props) => {
    const widget = this.props.widgetComponents[item.widgetType]
    return (
      <div key={index} {...widget.outerProps}>
        {widget.component(item, props)}
      </div>
    )
  }
  render () {
    const { dashboard, localize } = this.props
    if (dashboard.fetching) { return <LoadingIndicator /> }
    if (dashboard.items.length === 0) {
      return (
        <React.Fragment key={dashboard.componentKey}>
          <NoWidgetsMessage />
        </React.Fragment>
      )
    }
    return (
      <React.Fragment key={dashboard.componentKey}>
        {dashboard.items.map((item, index) => this.renderWidget(item, index, { localize }))}
      </React.Fragment>
    )
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    dashboard: state.dashboard,
    ...ownProps
  }
}

const mapDispatchToProps = {
  getDashboardWidgets: actionCreators.getDashboardWidgets
}

export default connect(mapStateToProps, mapDispatchToProps)(Widgets)



// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/index.js